var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18837_116569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.55556 10.0004C5.55556 7.54557 7.54514 5.55599 10 5.55599C12.4549 5.55599 14.4444 7.54557 14.4444 10.0004C14.4444 12.4553 12.4549 14.4449 10 14.4449C7.54514 14.4449 5.55556 12.4553 5.55556 10.0004ZM10 12.7782C11.5347 12.7782 12.7778 11.5352 12.7778 10.0004C12.7778 8.46571 11.5347 7.22266 10 7.22266C9.9757 7.22266 9.95487 7.22266 9.89931 7.22266C9.9757 7.39974 10 7.58724 10 7.77821C10 9.00391 9.00348 10.0004 7.77778 10.0004C7.58681 10.0004 7.39931 9.97613 7.22223 9.89974C7.22223 9.9553 7.22223 9.97613 7.22223 9.96918C7.22223 11.5352 8.46528 12.7782 10 12.7782ZM3.3132 5.02127C4.94792 3.50182 7.19445 2.22266 10 2.22266C12.8056 2.22266 15.0521 3.50182 16.6875 5.02127C18.3125 6.52821 19.3993 8.30252 19.9132 9.57335C20.0278 9.84766 20.0278 10.1532 19.9132 10.4275C19.3993 11.6671 18.3125 13.4414 16.6875 14.9796C15.0521 16.5004 12.8056 17.7782 10 17.7782C7.19445 17.7782 4.94792 16.5004 3.3132 14.9796C1.6882 13.4414 0.602088 11.6671 0.0854557 10.4275C-0.0284852 10.1532 -0.0284852 9.84766 0.0854557 9.57335C0.602088 8.30252 1.6882 6.52821 3.3132 5.02127ZM10 3.88932C7.73612 3.88932 5.875 4.9171 4.44792 6.24002C3.11112 7.48307 2.1882 8.92752 1.71667 10.0004C2.1882 11.0421 3.11112 12.5178 4.44792 13.7608C5.875 15.0838 7.73612 16.1115 10 16.1115C12.2639 16.1115 14.125 15.0838 15.5521 13.7608C16.8889 12.5178 17.7813 11.0421 18.2847 10.0004C17.7813 8.92752 16.8889 7.48307 15.5521 6.24002C14.125 4.9171 12.2639 3.88932 10 3.88932Z",
    fill: "#707A83"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18837_116569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.76a94ec9f1e3fa48d9dc647ed884e92d.svg";
export { ForwardRef as ReactComponent };